import React from "react";
import "./Main.css";
import About from "./About/About";
import Suggestion from "./Suggestion/Suggestion";
import Collaboration from "./Collaboration/Collaboration";
import Information from "./Information/Information";

function Main({ isLoading, scrollItem, onScrollItem, onScrollDown }) {
  const [isActiveSuggestion, setIsActiveSuggestion] = React.useState(false);
  const [isActiveCollaboration, setIsActiveCollaboration] = React.useState(false);
  const [isActiveInformation, setIsActiveInformation] = React.useState(false);
  let prevYPos = React.useRef(0);


  React.useEffect(() => {
    function checkScroll() {

      window.pageYOffset > 100
        ? setIsActiveSuggestion(true)
        : setIsActiveSuggestion(false);
      window.pageYOffset > 350
        ? setIsActiveCollaboration(true)
        : setIsActiveCollaboration(false);
      window.pageYOffset > 650
        ? setIsActiveInformation(true)
        : setIsActiveInformation(false);
    }

    function checkScrollDown() {
      if (window.pageYOffset >= prevYPos.current && window.pageYOffset > 20) {
        onScrollDown(true);
      } else {
        onScrollDown(false);
      }
      prevYPos.current = window.pageYOffset;
    }

    window.addEventListener("scroll", checkScroll);
    window.addEventListener("scroll", checkScrollDown);
    window.addEventListener("touchend", checkScroll);

    return () => {
      window.removeEventListener("scroll", checkScroll);
      window.removeEventListener("scroll", checkScrollDown);
      window.removeEventListener("touchend", checkScroll);
    };
  }, [onScrollDown, scrollItem]);
  return (
    <main
      className={`main page__container ${
        isLoading ? "inactive" : "active appear"
      }`}
    >
      <About />
      <Suggestion
        isActiveSuggestion={isActiveSuggestion}
        scrollItem={scrollItem}
        onScrollItem={onScrollItem}
      />
      <Collaboration
        isActiveCollaboration={isActiveCollaboration}
        scrollItem={scrollItem}
        onScrollItem={onScrollItem}
      />
      <Information
        isActiveInformation={isActiveInformation}
        scrollItem={scrollItem}
        onScrollItem={onScrollItem}
      />
    </main>
  );
}

export default Main;
